import React from "react";
import UserAddressListItem from "../../components/userAddress/UserAddressList/UserAddressListItem";
import {Box} from "@mui/material";
import {useParams} from "react-router";
import {useTitle} from 'react-use';
import { t } from "@lingui/core/macro";

const UserAddressListPage = ()  => {

    useTitle(t`List User Address`);
    
    const allQueries = useParams()
    const query = Object.fromEntries(
        Object.entries(allQueries).filter(([key]) => key.endsWith("Id"))
    )
    
    return (
        <Box>
            <UserAddressListItem showAdd={true} {...query} />
        </Box>
    )
}

export default UserAddressListPage;
